"use memo"

import { AutopilotTaskDto } from '@urbanx/agx.activities.client'
import ExchangeTaskEntry from './ExchangeTaskEntry'

interface SolicitorExchangeProps {
  campaignId: string
  task: AutopilotTaskDto
}

const SolicitorExchange = ({ campaignId, task }: SolicitorExchangeProps) => (
  <ExchangeTaskEntry
    actionButtonId="completeSolicitorExchangeBtn"
    campaignId={campaignId}
    panelKey="SolicitorExchangePanel"
    task={task}
    title="Solicitor Exchange"
  />
)

export default SolicitorExchange
